import { render, staticRenderFns } from "./inputNumberV3.vue?vue&type=template&id=05bd9e15&scoped=true"
import script from "./inputNumberV3.vue?vue&type=script&lang=ts"
export * from "./inputNumberV3.vue?vue&type=script&lang=ts"
import style0 from "./inputNumberV3.vue?vue&type=style&index=0&id=05bd9e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd9e15",
  null
  
)

export default component.exports